import { type QuizData, type QuizListInput, type QuizListSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { quizListKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useQuizzes(input?: QuizListInput): GetHookResponse<QuizData[]> {
  return useTantalimQuery<QuizListInput, QuizListSuccess, QuizData[]>({
    url: '/quiz/list',
    queryKey: quizListKey(input),
    input: input ?? {},
    convertResponse: (data) => data.quizzes,
  })
}
